<template>
	<div>
		<el-dialog :width="pageType==1?'387px':'1196px'" :visible.sync="show" @close="close()"
			:close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
			<div class="wheel_dialog_box" :class="pageType==2?'wheel_dialog_box2 wheel_detail_bg':''"
				
			>
				<div class="wheel_dialog_top_box" v-if="pageType==1">
					<div class="wheel_dialog_top">
						<div class="wheel_dialog_top_title">
						</div>
						<div class="wheel_dialog_top_close">
							<img @click="close" class="wheel_dialog_top_close_icon"
								src="../../../assets/icons/close_icon.png" alt="" />
						</div>
					</div>
				</div>
				<div v-else>
					<!-- 详情页关闭按钮 -->
					<img @click="pageType=1" class="wheel_dialog_top_close_icon detail_close"
						src="../../../assets/icons/close_icon.png" alt="" />
				</div>

				<div v-if="pageType==1" class="wheel_dialog_content">
					<div class="wheel_list">
						<div class="wheel_list_item" v-for="item in wheelList" :key="item.id"
							@click="clickWheelItem(item)">
							<img class="wheel_list_item_icon"
								:src="require(`/src/assets/icons/wheel_icon${item.icon}.png`)" alt="" />
							{{item.name}}
						</div>
					</div>

					<div class="wheel_list_remark">
						NB: The respective spins above contain different <br>
						promotions, bonuses and activities.
					</div>
				</div>
				<div v-else-if="pageType==2" class="wheel_detail" v-loading="loading">
					<div class="wheel_detail_left">
						<LuckyWheel ref="myLucky" width="520px" height="520px" :prizes="prizes" :blocks="blocks"
							:buttons="buttons" @start="startCallback" @end="endCallback" />
						<div class="wheel_detail_left_name">
							{{whellData.rewardCount}} spins left
						</div>
						<div @click="startCallgo" class="wheel_detail_left_btn def_btn" v-if="curWheel!=3">
							Get more
						</div>
					</div>
					<div class="wheel_detail_right">
						<div class="wheel_detail_right_top" v-if="curWheel==1"> 
							<div class="wheel_detail_right_title">
								Wheel Description
							</div>
							<div class="wheel_detail_right_remark">
								Deposit Spin: Get free spins when you deposit. <br />
								The higher your deposit in a day, the more spins you get. <br />
								Note: Free spins is valid for 24 hours.
							</div>
						</div>
						<div class="wheel_detail_right_top" v-if="curWheel==2"> 
							<div class="wheel_detail_right_title">
								Wheel Description
							</div>
							<div class="wheel_detail_right_remark">
								Betting Spin: Get free spins as you play. The more you play the more spins you get.<br />
								Note: Bet spins are given by the total amount of bets made in a day. Spins are valid for 24 hours.
							</div>
						</div>
						<div class="wheel_detail_right_top" v-if="curWheel==3"> 
							<div class="wheel_detail_right_title">
								Wheel Description
							</div>
							<div class="wheel_detail_right_remark">
								Daily Login Spin: Login everyday and get your daily free spin. <br />
								Note: Spins are valid for 24 hours.
							</div>
						</div>
						<div class="wheel_detail_right_list" v-if="curWheel!==3">
							<div class="wheel_detail_right_list_item">
								<div class="wheel_detail_right_list_item_left" v-if="curWheel==1">
									Deposit amount
								</div>
								<div class="wheel_detail_right_list_item_left" v-if="curWheel==2">
									Betting amount
								</div>
								<div class="wheel_detail_right_list_item_right">
									Spin times
								</div>
							</div>
							<div class="wheel_detail_right_list_item" v-for="item in rewardLevelList"
								:key="item.rewardSettingId">
								<div class="">
									{{item.rewardSettingAmount}}
								</div>
								<div class="">
									{{item.rewardSettingNumber}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 抽奖后提示 -->
		<el-dialog width="482px" :visible.sync="tipShow" :close-on-click-modal="false" :close-on-press-escape="false"
			:show-close="false">
			<div class="wheel_dialog_tip_box">
				<!-- 提示框关闭按钮 -->
				<img @click="tipShow=false" class="wheel_dialog_top_close_icon detail_close"
					src="../../../assets/icons/close_icon.png" alt="" />
				<div v-if="tipType==1" class="wheel_dialog_tip_content wheel_dialog_tip_content_set">
					<div></div>
					<div class="wheel_dialog_tip_info">
						<div class="wheel_dialog_tip_info_title">
							You won
						</div>
						<div class="wheel_dialog_tip_info_price">
							₦{{lotteryDrawPrice?lotteryDrawPrice:0}}
						</div>
					</div>
				</div>
				<div v-if="tipType>1" class="wheel_dialog_tip_content wheel_dialog_tip_contentbg2">
					<div class="wheel_dialog_tip_content_oops">Oops</div>
					<div class="wheel_dialog_tip_content_oops_remark">
						<div v-if="tipType==2">
							Try <br>
							again
						</div>
						<div v-else-if="tipType==3">
							Nice<br>
							try
						</div>

					</div>
				</div>

				<div class="wheel_dialog_tip_btn def_btn" @click="clickTipBtn()">
					Continue
				</div>
			</div>
		</el-dialog>

		<walletDialog :walletShow="signInShow" @close="signInShow=false"></walletDialog>
	</div>
</template>

<script>
	import walletDialog from './walletDialog.vue'
	import { mapState } from 'vuex';
	export default {
		name: 'luckyWheelPage',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			...mapState(['user']), // 映射 user 模块下的 userInfo 状态
		},
		components: {
			walletDialog
		},		data() {
			return {
				loading:false,
				
				pageType: 1, //1转盘列表页  2转盘详情页
				tipType: 1, //1中奖提示  2未中奖提示  3再来一次


				tipShow: false, //提示弹窗
				signInShow:false,
				// 轮盘列表
				curWheel: 1, //当前选中的轮盘
				wheelList: [{
						id: 1,
						name: 'Deposit spin',
						icon: 1,
					},
					{
						id: 2,
						name: 'Bet spin',
						icon: 2,
					},
					{
						id: 3,
						name: 'Daily login Spin',
						icon: 3,
					}
				],
				blocks: [{
					padding: '60px',
					background: '',
					imgs: [{
						src: require(`../../../assets/icons/wheel_bg1.png`),
						width: '512px',
						height: '512px',
						top: '3px',
						rotate: true,
					}, ]
				}, ],
				prizes: [{
						fonts: [{
							text: '0',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '1',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '2',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '3',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '4',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '5',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '6',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '7',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '8',
							top: '10%',
							id: '',
						}],
					},
					{
						fonts: [{
							text: '9',
							top: '10%',
							id: '',
						}],
					},
				],
				buttons: [{
					radius: '20%',
					imgs: [{
						src: require('../../../assets/icons/wheel_needle1.png'),
						width: '96px',
						height: '121.64px',
						top: '-70px',
					}, ],
				}],
				whellData: {
					rewardList: [], //礼物列表
				}, //转盘总信息
				rewardLevelList: [], //获取抽奖信息
				// 抽奖
				// 是否可以抽奖
				lotteryDrawData: {}, //抽奖结果信息
				lotteryDrawType: true, //抽奖状态
				lotteryDrawPrice: '', //抽中的金额



			}
		},
		mounted() {
			// this.clickWheelItem(1)
		},
		methods: {
			close() {
				this.$emit('close')
			},
			clickWheelItem(item) {
				this.$api.getWheel({
					rewardMode: item.id
				}).then(res => {
					this.curWheel = item.id
					this.rewardLevelList = res.data.RewardLevelList
					this.whellData = res.data


					if (res.data.rewardList && res.data.rewardList.length > 0) {
						res.data.rewardList.forEach((item, i) => {
							this.prizes[i].fonts[0].text = item.rewardName
							this.prizes[i].fonts[0].id = item.rewardId
						})
					}
					this.blocks[0].imgs[0].src = require(`../../../assets/icons/wheel_bg${item.icon}.png`)
					this.buttons[0].imgs[0].src = require(`../../../assets/icons/wheel_needle${item.icon}.png`)
					this.pageType = 2
				})
			},
			// 点击抽奖按钮会触发star回调
			startCallback() {
				if (this.lotteryDrawType) {
					this.lotteryDrawType = false
					// 调用接口获取抽奖结果
					let apiName = 'wheelOne';
					if (this.curWheel == 1) {
						apiName = 'wheelOne'
					} else if (this.curWheel == 2) {
						apiName = 'wheelToo'
					} else if (this.curWheel == 3) {
						apiName = 'wheelThree'
					}
					this.loading = true
					setTimeout(()=>{
						this.loading = false
					},3000)
					this.$api[apiName]({})
						.then(res => {
							this.lotteryDrawData = res.data

							// 调用抽奖组件的play方法开始游戏
							this.$refs.myLucky.play()
							this.whellData.rewardCount--

							// 抽奖指针要选中索引 
							let index = 0;
							this.whellData.rewardList.forEach((item, i) => {
								if (item.rewardId == res.data.rewardId) {
									index = i
								}
							})
							this.$store.dispatch('GetInfo')
							setTimeout(() => {
								// 调用stop停止旋转并传递中奖索引
								this.$refs.myLucky.stop(index)
							}, 3000)
						})
						.finally(res => {
							this.loading = false
							this.lotteryDrawType = true
						})

					// 埋点转盘
					this.$track.track('rotatingdiscActivity',{
						userId:this.user.userId,
						turntableType:this.curWheel==1?'recharge':this.curWheel==2?'bet':'login',
						reward:this.lotteryDrawPrice
						// consecutiveDays  连续签到的天数（待定）
					});
					this.$use.sendGoogleEvent('rotatingdiscActivity')
				}
			},
			// 抽奖结束会触发end回调
			endCallback(prize) {
				let data = JSON.parse(JSON.stringify(this.lotteryDrawData))
				// tipType: 1, //1中奖提示  2未中奖提示  3再来一次
				// data.rewardType==1 抽中 奖励抽奖次数  !=1 金币
				if (data.rewardType == '1') {
					// 如果是抽中奖励次数  rewardNumber字段代表奖励几次
					this.whellData.rewardCount += data.rewardNumber
					this.tipType = 3
				} else {
					// 如果是抽中余额不是奖励次数 rewardNumber字段代表多少金额
					// 如果为0 则是未中奖
					if (data.rewardNumber != 0) {
						this.tipType = 1
						this.lotteryDrawPrice = data.rewardNumber
					} else {
						this.tipType = 2
						this.lotteryDrawPrice = 0
					}
				}
				this.tipShow = true
				this.$store.dispatch('GetInfo')
			},
			// 点击提示框按钮
			clickTipBtn() {
				this.tipShow = false
				this.tipType = 0
				this.startCallback()
			},
			startCallgo(){
				if(this.curWheel == 1){
					this.close()
					// this.signInShow = true
					// this.$router.push({
					// 	name: 'homePage',
					// 	query: { showModal: true}
					// });
					// this.$store.commit('SET_EXTERNAL_MODAL', true);
      
      
					// this.$router.push({ name:'homePage' })
				}else if(this.curWheel == 2){
					this.close()
					this.$router.push({ name:'homePage' })
				}else if(this.curWheel == 3){
					this.close()
					this.$router.push({ name:'promotions' })
				}
			},


		}
	}
</script>


<style scoped lang="scss">
	.wheel_dialog_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 494px;
		min-height: 393px;
		max-height: 800px;
		background: #1F242F;
		border-radius: 18px;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.wheel_dialog_box2 {
		width: 1196px;
		min-width: 1196px;
	}

	.wheel_dialog_top_box {
		width: 100%;
		min-height: 87px;
		height: 87px;
		border-radius: 18px 18px 0 0;
	}

	.wheel_dialog_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 87px;
		color: #F0F0F0;
		font-size: 22px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.wheel_dialog_top_title {
		color: #F0F0F0;
		font-size: 24px;
	}

	.wheel_dialog_top_close {
		width: 43.38px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.wheel_dialog_top_close_icon {
		width: 46.4px;
		height: 46.4px;
		cursor: pointer;
	}

	.wheel_dialog_content {
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
	}

	.wheel_list {
		width: 100%;
	}

	.wheel_list_item {
		width: 100%;
		height: 48px;
		background: linear-gradient(134deg, rgba(4, 29, 53, 0.6) 28%, rgba(19, 63, 144, 0.4) 55%, #2D76FF 99%);
		border-radius: 6px;
		margin-bottom: 12px;
		box-sizing: border-box;
		padding: 0 16px;
		display: flex;
		align-items: center;

		font-weight: 600;
		font-size: 16px;
		color: #FFFFFF;
		cursor: pointer;
	}

	.wheel_list_item_icon {
		height: 48px;
		margin-right: 30px;
	}

	.wheel_list_item:nth-child(2) {
		background: linear-gradient(339deg, #634FD5 0%, rgba(65, 42, 146, 0.4) 50%, rgba(30, 6, 79, 0.6) 100%);
	}

	.wheel_list_item:nth-child(3) {
		background: linear-gradient(261deg, rgba(50, 204, 88, 0.8) 0%, rgba(38, 140, 85, 0.4) 55%, rgba(25, 49, 36, 0.6) 97%);
	}

	.wheel_list_remark {
		width: 100%;

		height: 71px;
		background: #1A1F29;
		border-radius: 6px;
		border: 1px solid #242A37;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding: 0 11px;


		font-weight: 400;
		font-size: 15px;
		color: #FFFFFF;
		line-height: 16px;
		margin-top: 36px;
	}



	.wheel_detail_bg {
		background-size: contain;
		background: linear-gradient(125deg, #192E2B 0%, #161821 100%);
	}

	.wheel_detail {
		width: 100%;
		box-sizing: border-box;
		padding: 50px 70px 45px;
		display: flex;
		justify-content: space-between;
	}

	.detail_close {
		position: absolute;
		top: 20px;
		right: 20px;
	}

	.wheel_detail_left {
		width: 514px;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.wheel_detail_left_name {
		font-size: 20px;
		color: #fff;
		margin-top: 23px;
	}

	.wheel_detail_left_btn {
		width: 141px;
		height: 52px;
		margin-top: 16px;
	}

	.wheel_detail_right {
		width: 428px;
		box-sizing: border-box;
		padding-top: 40px;
	}

	.wheel_detail_right_top {
		text-align: center;
	}

	.wheel_detail_right_title {
		font-weight: 500;
		font-size: 21px;
		color: #FFFFFF;
	}

	.wheel_detail_right_remark {
		color: #7F8BA0;
		margin-top: 20px;
		line-height: 24px;
		text-align: left;
	}

	.wheel_detail_right_list {
		margin: 35px auto 0;
		width: 392px;
		background-color: #1B202A;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 10px 20px;
	}

	.wheel_detail_right_list_item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 40px;
		border-bottom: 1px solid #64696D;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
	}

	.wheel_detail_right_list_item:first-child {
		font-weight: 500;
		font-size: 20px;
		color: #A3BAE0;
		line-height: 20px;
	}

	.wheel_detail_right_list_item:last-child {
		border-bottom: none;
	}





	.wheel_dialog_tip_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		min-height: 698px;
		color: #fff;
		z-index: 9;
		background-color: #1F242F;
		box-sizing: border-box;
		padding: 80px 49px 41px;
		border-radius: 20px;
	}

	.wheel_dialog_tip_content {
		width: 100%;
		height: 435.75px;
		background-image: url('../../../assets/icons/tip_icon6.png');
		background-size: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 0 0 80px;
	}

	.wheel_dialog_tip_content_set {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 0 0 80px;
	}

	.wheel_dialog_tip_contentbg2 {
		justify-content: center;
		background-image: url('../../../assets/icons/tip_icon7.png');
	}

	.wheel_dialog_tip_content_oops {
		font-size: 23.38px;

	}

	.wheel_dialog_tip_content_oops_remark {
		text-align: center;
		font-size: 60px;
		line-height: 70px;
		margin-top: 50px;
		color: #98E528;

	}


	.wheel_dialog_tip_info {
		text-align: center;
	}

	.wheel_dialog_tip_info_title {
		font-size: 26px;
		font-weight: bold;
	}

	.wheel_dialog_tip_info_price {
		font-size: 60px;
		font-weight: bold;
		margin-top: 50px;
		color: #98E528;
	}

	.wheel_dialog_tip_btn {
		width: 204px;
		height: 55px;
		margin: 92px auto 0;
	}
</style>